

import { DynamicScrollerItem } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
  name: 'SDynamicScrollerItem',
  components: {
    DynamicScrollerItem,
  },
  inheritAttrs: false,
};

